export const accountKeys = {
  all: ["account"] as const,
  account: ["account", "info"] as const,
  invitationLink: ["account", "invitation-link"] as const,
  token: ["account", "token"] as const,
  invoices: ["account", "invoices"] as const,
  cancellationDiscount: ["account", "cancellation-discount"] as const,
  discountEligibility: ["account", "discount-eligibility"] as const,
  search: (search: string) => ["account", "search", search] as const,
};
